import { createFeatureFlagSignal } from '@rma/common-ui-ng/feature-flags/internal';
import { FeatureFlag } from '../domain/feature-flags.enum';

export const featureFlagSignal = createFeatureFlagSignal<FeatureFlag>();
